import { render, staticRenderFns } from "./PayDevices.vue?vue&type=template&id=b145e74e"
import script from "./PayDevices.vue?vue&type=script&lang=js"
export * from "./PayDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports